export const PENDING = 'PENDING';
export const FAILED = 'FAILED';
export const SUCCESS = 'SUCCESS';
